import React from 'react';
import useVisitorStats from '../hooks/useVisitorStats';

const GalleryStatsBar = () => {
  const { loading, totalVisitors, onlineVisitors } = useVisitorStats();

  if (loading) {
    return (
      <div className="alert alert-light border text-muted py-2 px-3" role="status">
        جاري تحميل إحصائيات الزوار...
      </div>
    );
  }

  return (
    <div className="alert alert-primary d-flex justify-content-center gap-3 flex-wrap py-2 px-3" role="status">
      <span><strong>إجمالي الزوار:</strong> {totalVisitors}</span>
      <span><strong>المتصلون الآن:</strong> {onlineVisitors}</span>
    </div>
  );
};

export default GalleryStatsBar;
